export default __webpack_public_path__ + "static/media/category.bf0fd92b.png";